var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-dropdown"},[_c('v-btn',{attrs:{"fab":"","flat":"","dark":"","small":""}},[_c('v-icon',[_vm._v("mdi-bell-outline mdi-24px")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }